import { keyboardEvents } from '../Utilities/AccessibilityUtilities.js';
const focusableElements = 'button:not(:disabled),[href],input:not(:disabled),select:not(:disabled),textarea:not(:disabled),[tabindex]:not([tabindex="-1"])';
const getActiveElement = (focusedElement, focusableContent) => {
  if (focusableContent.includes(focusedElement)) {
    return focusedElement;
  }
  const shadowRoot = focusedElement?.shadowRoot;
  if (!shadowRoot?.activeElement) {
    return focusableContent[focusableContent.length - 1];
  }
  focusedElement = shadowRoot?.activeElement;
  return getActiveElement(focusedElement, focusableContent);
};
export const modalFocusHandler = element => {
  let firstFocusableElement = null;
  const prevFocusableElement = document?.activeElement;
  const focusHandler = e => {
    const focusableContentArray = element.querySelectorAll(focusableElements);
    const focusableContent = [];
    for (let i = 0; i < focusableContentArray.length; i += 1) {
      const style = window.getComputedStyle(focusableContentArray[i]);
      if (style.display !== 'none' && style.visibility !== 'hidden') {
        if (['radio'].includes(focusableContentArray[i].type)) {
          const existedElement = focusableContent.find(oldElement => oldElement.name === focusableContentArray[i].name);
          if (!existedElement && focusableContentArray[i].checked) {
            focusableContent.push(focusableContentArray[i]);
          }
        } else {
          focusableContent.push(focusableContentArray[i]);
        }
      }
    }
    const lastFocusableElement = focusableContent[focusableContent.length - 1];
    [firstFocusableElement] = focusableContent;
    const pressedKey = e.key;
    let focusedElement = document?.activeElement;
    focusedElement = getActiveElement(focusedElement, focusableContent);
    if (![keyboardEvents.Escape, keyboardEvents.Tab].includes(pressedKey)) {
      return;
    }
    e.preventDefault();

    /* Customize tab flow */
    switch (focusedElement) {
      case firstFocusableElement:
        {
          // if only the content is focusable, keep user in overlay.
          if (focusableContent.length === 1) {
            return;
          }
          // if focus is on firstFocusableElement: Shift + Tab -> Focus on last focusable element
          if (e.shiftKey) {
            if (lastFocusableElement) {
              lastFocusableElement.focus();
            }
            return;
          }
          break;
        }
      case lastFocusableElement:
        {
          // if focus is on lastFocusableElement: Tab -> Focus on first focusable element
          if (!e.shiftKey) {
            if (firstFocusableElement) {
              firstFocusableElement.focus();
            }
            return;
          }
          break;
        }
      default:
        {
          // Proceed with regular tab flow
        }
    }
    const currentIndex = focusableContent.indexOf(focusedElement);
    if (e.shiftKey) {
      if (focusedElement !== firstFocusableElement) {
        focusableContent[currentIndex - 1].focus();
      }
    } else if (focusedElement !== lastFocusableElement) {
      focusableContent[currentIndex + 1].focus();
    }
  };
  return {
    focusHandler,
    prevFocusableElement
  };
};
export default modalFocusHandler;